import { useEffect, useState } from "react";

// true only in a real browser, after hydration has finished. Stays false while
// scripts/prerender.js is taking its snapshot (it sets window.__PRERENDER__), so the
// snapshot and the visitor's first render contain the same placeholder markup.
// Use it for UI that depends on "now", the viewport, or a third-party widget that
// rewrites its own DOM on mount: anything that would otherwise differ between the
// build-time snapshot and what the visitor's browser renders (React #418/#425).
export default function useClientReady() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!window.__PRERENDER__) setReady(true);
  }, []);
  return ready;
}
